<template>
  <div class="footer -shadow-lg">
    <div class="footer-section">
      <Image
        imageUrl="logo_barmanager_black.svg"
        altText="logo"
        class="logo-barmanager"
        :api="false"
      />
      <p>{{getFooterTrans.colaboration}}</p>
      <Image
        :imageUrl="getLogo"
        :altText="getLogoAlt"
        class="logo"
        :api="true"
        v-if="getLogo && getLogoAlt"
      />
    </div>
    <div class="footer-section">
      <button class="btn-footer" @click="showDeleteModal">{{getFooterTrans.delete_account}}</button>
      <a class="btn-footer" href="mailto:participa@barmanagerapp.com">{{getFooterTrans.contact}}</a>
      <a class="btn-footer" @click="openLink('legal_advise')">{{getFooterTrans.legal_advise}}</a>
    </div>
    <div class="footer-section">
      <a class="btn-footer" @click="openLink('legal_bases')">{{getFooterTrans.legal_bases}}</a>
      <a class="btn-footer" @click="openLink('policy')">{{getFooterTrans.privacy_policy}}</a>
      <a class="btn-footer" @click="openLink('cookies_policy')">{{getFooterTrans.cookies_policy}}</a>
    </div>
  </div>
</template>

<script>
import Image from '@/components/Image.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  components: {
    Image
  },
  computed: {
    ...mapGetters(['getFooterTrans', 'getLogo', 'getLogoAlt'])
  },
  methods: {
    showDeleteModal () {
      this.$vfm.show('deleteAccountModal')
    },
    openLink (url) {
      const partialPath = this.$route.params.preview === 'preview' ? `${this.$route.params.alias_url}/preview` : `${this.$route.params.alias_url}`
      window.open(`${process.env.VUE_APP_BASE_URL_LAND}${partialPath}/${url}`, '_blank')
    }
  }
}
</script>

<style scoped>
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-top: auto;
  padding: 1rem;
}
@media (min-width: 768px) {
  .footer {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.footer-section {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.logo-barmanager {
  margin-top: 1rem;
  margin-bottom: 1rem;
  width: 120px;
}
.logo {
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  width: 180px;
}
.btn-footer {
  cursor: pointer;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  text-align: left;
  color: var(--primary);
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
</style>
